/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function specificationVarietyPreferences(instance) {
	return {
		/**
		 * @param {number} varietyId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		get: (varietyId, config = {}) => {
			return instance.get(
				`retailers/specifications/variety_preferences/${varietyId}`,
				config
			)
		},

		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAll: (pageNumber, pageSize, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(
				`retailers/specifications/variety_preferences${params}`,
				config
			)
		},

		/**
		 * @param {number} varietyId
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		edit: (varietyId, body, config = {}) => {
			return instance.put(
				`retailers/specifications/variety_preferences/${varietyId}`,
				body,
				config
			)
		},

		/**
		 * @param {number} varietyId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		delete: (varietyId, config = {}) => {
			return instance.delete(
				`retailers/specifications/variety_preferences/${varietyId}`,
				config
			)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		create: (body, config = {}) => {
			return instance.post(
				'retailers/specifications/variety_preferences',
				body,
				config
			)
		},

		/**
		 * @param {number} specificationId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllBySpecificationId: (
			specificationId,
			pageNumber,
			pageSize,
			config = {}
		) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(
				`retailers/specifications/${specificationId}/variety_preferences${params}`,
				config
			)
		}
	}
}
